/* global axios */
import store from '../store';

const API_VERSION = 'api/v1';

class GoogleCalendarAPI {
  get accountId() {
    return store.state.auth.currentUser.account_id;
  }

  get baseUrl() {
    return `/${API_VERSION}/accounts/${this.accountId}/google_calendar`;
  }

  // Get integration status for a funnel
  async getStatus(funnelId) {
    return axios.get(`${this.baseUrl}/status`, {
      params: { funnel_id: funnelId },
    });
  }

  // Get authorization URL
  async authorize(funnelId) {
    return axios.get(`${this.baseUrl}/authorize`, {
      params: { funnel_id: funnelId },
    });
  }

  // Disconnect integration
  async disconnect(funnelId) {
    return axios.delete(`${this.baseUrl}/disconnect`, {
      params: { funnel_id: funnelId },
    });
  }

  // List events from Google Calendar
  async getEvents(funnelId, timeMin, timeMax) {
    return axios.get(`${this.baseUrl}/events`, {
      params: {
        funnel_id: funnelId,
        time_min: timeMin,
        time_max: timeMax,
      },
    });
  }

  // Create a new event
  async createEvent(funnelId, eventData) {
    return axios.post(`${this.baseUrl}/create_event`, {
      funnel_id: funnelId,
      ...eventData,
    });
  }

  // Update an existing event
  async updateEvent(funnelId, eventId, eventData) {
    return axios.patch(`${this.baseUrl}/update_event`, {
      funnel_id: funnelId,
      event_id: eventId,
      ...eventData,
    });
  }

  // Delete an event
  async deleteEvent(funnelId, eventId) {
    return axios.delete(`${this.baseUrl}/delete_event`, {
      params: {
        funnel_id: funnelId,
        event_id: eventId,
      },
    });
  }

  // Trigger manual sync
  async sync(funnelId) {
    return axios.post(`${this.baseUrl}/sync`, {
      funnel_id: funnelId,
    });
  }

  // Update integration settings
  async updateSettings(funnelId, settings) {
    return axios.patch(`${this.baseUrl}/settings`, {
      funnel_id: funnelId,
      ...settings,
    });
  }

  // List available calendars
  async getCalendars(funnelId) {
    return axios.get(`${this.baseUrl}/calendars`, {
      params: { funnel_id: funnelId },
    });
  }
}

export default new GoogleCalendarAPI();
